import { LinkLikeButton } from 'components/core/button'
import { toast } from 'lib/components/toast/toast'

const AddToToastActions = ({ url, type }: { url: string; type: string }) => {
  return (
    <>
      <LinkLikeButton
        className="tw-ml-4 tw-text-nowrap tw-text-inherit"
        onClick={() => {
          navigator.clipboard.writeText(url)
          toast.success(`Link to ${type} copied`)
        }}
      >
        Copy link
      </LinkLikeButton>
      <LinkLikeButton
        className="tw-ml-4 tw-text-nowrap tw-text-inherit"
        onClick={() => {
          window.open(url, '_blank')
        }}
      >
        View
      </LinkLikeButton>
    </>
  )
}

export default AddToToastActions
